export default __webpack_public_path__ + "static/media/freight-receipt-light.cf62940a.svg";